import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClientBusiness from './ClientBusiness';
import {
  getClientBusinessDetails
} from "services/redux/sales/corporate/pocDetails/action";

const mapStateToProps = (state) => ({
  clientBusiness: state.pocTypesReducer.clientBusiness
  });
  
  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        getClientBusinessDetails
      },
      dispatch
    );
  
  export default connect(mapStateToProps, mapDispatchToProps)(ClientBusiness);